import React from 'react';
import { motion } from 'framer-motion';

interface ScreenFlashProps {
  type: 'success' | 'failure' | 'levelup';
}

const ScreenFlash: React.FC<ScreenFlashProps> = ({ type }) => {
  const getColor = () => {
    switch (type) {
      case 'success': return 'bg-green-500';
      case 'failure': return 'bg-red-500';
      case 'levelup': return 'bg-gradient-to-r from-neon-purple via-neon-blue to-neon-pink';
      default: return 'bg-white';
    }
  };

  return (
    <motion.div
      className={`absolute inset-0 ${getColor()} pointer-events-none z-40`}
      initial={{ opacity: 0.4 }}
      animate={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    />
  );
};

export default ScreenFlash;
